export default `
# Místo konference

Orea Hotel Voroněž

Křížkovského 458, Brno, Česká Republika
`



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/venue/text.js